import { prefersReducedMotion } from "@js/parts/prefersReducedMotion";

export default (config = {}) => ({
  position: 0,
  animationFrame: null,
  useGlobalScroll: config.useGlobalScroll || false,
  scrollSpeed: config.scrollSpeed || 0.5,

  init() {
    if (prefersReducedMotion()) {
      this.position = 0;
      return;
    }

    this.updatePosition();
    window.addEventListener('scroll', this.handleScroll.bind(this));
  },

  handleScroll() {
    if (this.animationFrame) {
      cancelAnimationFrame(this.animationFrame);
    }
    this.animationFrame = requestAnimationFrame(() => this.updatePosition());
  },

  updatePosition() {
    if (this.useGlobalScroll) {
      // Use global scroll position for continuous movement
      const scrollY = window.scrollY;
      const elementWidth = this.$el.offsetWidth;
      const sweepRange = elementWidth * 2;

      // Create a continuous sweep based on scroll position
      // Use configurable scroll speed multiplier
      this.position = -elementWidth + ((scrollY * this.scrollSpeed) % sweepRange);
    } else {
      // Original element-relative positioning
      const rect = this.$el.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      // Calculate scroll progress as element moves through viewport
      const elementTop = rect.top;
      const elementBottom = rect.bottom;

      let scrollProgress;
      if (elementBottom > windowHeight) {
        scrollProgress = 0;
      } else if (elementTop < 0) {
        scrollProgress = 1;
      } else {
        const totalScrollDistance = windowHeight + rect.height;
        const currentScrollDistance = windowHeight - elementTop;
        scrollProgress = currentScrollDistance / totalScrollDistance;
      }

      // Convert to pixel position
      const elementHeight = rect.height;
      const sweepRange = elementHeight * 2;
      this.position = -elementHeight + (scrollProgress * sweepRange);
    }
  },

  destroy() {
    window.removeEventListener('scroll', this.handleScroll.bind(this));
    if (this.animationFrame) {
      cancelAnimationFrame(this.animationFrame);
    }
  },
});
